import React, { useEffect, useState } from "react";
import { PhoneCall } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, EmptyState, Loader, StatusBadge } from "@/components/dashboard/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSelect, SelectCheck, SelectionToolbar } from "@/components/admin/BulkBar";

const CB_STATUSES = ["Nouveau", "Pris en charge", "Rappel effectué", "Résolu"];

export default function AdminCallbacks() {
  const [cbs, setCbs] = useState(null);
  const [arch, setArch] = useState(false);
  const sel = useSelect();
  const load = () => api.get(`/callbacks?include_archived=${arch}`).then(({ data }) => setCbs(data || []));
  useEffect(() => { sel.clear(); load(); /* eslint-disable-next-line */ }, [arch]);
  const setStatus = async (c, status) => {
    try { await api.put(`/callbacks/${c.callback_id}`, { status }); toast.success("Mis à jour"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (cbs === null) return <Loader />;
  const news = cbs.filter((c) => c.status === "Nouveau");
  return (
    <div>
      <PageHeader title="Rappels urgents" subtitle="Demandes de rappel administratif des clients." />
      <SelectionToolbar items={cbs} idKey="callback_id" sel={sel} entity="callbacks" onDone={load} label="rappel" archived={arch} onToggleArchived={() => setArch((a) => !a)} />
      {news.length > 0 && <div className="mb-4 rounded-xl bg-rose-50 border border-rose-200 p-4 text-rose-800 text-sm font-medium">{news.length} demande(s) urgente(s) à traiter.</div>}
      {cbs.length === 0 ? <EmptyState icon={PhoneCall} title={arch ? "Aucun rappel archivé" : "Aucune demande de rappel"} /> : (
        <div className="space-y-3">{cbs.map((c) => (
          <div key={c.callback_id} className={`relative bg-white rounded-xl border p-5 pl-11 flex flex-wrap items-start justify-between gap-3 ${sel.has(c.callback_id) ? "border-primary ring-1 ring-primary/30" : c.status === "Nouveau" ? "border-rose-200" : "border-slate-200"}`} data-testid={`callback-${c.callback_id}`}>
            <SelectCheck className="absolute left-3 top-6" checked={sel.has(c.callback_id)} onChange={() => sel.toggle(c.callback_id)} testId={`select-callback-${c.callback_id}`} />
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap"><span className="font-semibold text-slate-900">{c.name}</span><span className="text-sm text-slate-400">{c.practice}</span><StatusBadge status={c.status} /></div>
              <p className="text-sm text-slate-600 mt-1"><strong>{c.subject}</strong></p>
              {c.description && <p className="text-sm text-slate-500 mt-0.5">{c.description}</p>}
              <p className="text-sm text-slate-500 mt-1">{c.phone} · Préférence : {c.preferred_time || "—"}</p>
            </div>
            <Select value={c.status} onValueChange={(v) => setStatus(c, v)}><SelectTrigger className="w-44" data-testid={`callback-status-${c.callback_id}`}><SelectValue /></SelectTrigger><SelectContent>{CB_STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent></Select>
          </div>))}
        </div>
      )}
    </div>
  );
}
